import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import App from './App.jsx';
import SiteContentProvider from './content/SiteContentProvider.jsx';

// Order matters: tokens define the variables, base consumes them for the
// reset and type scale, components build on both.
import './design/tokens.css';
import './design/base.css';
import './design/components.css';
import './design/pages.css';

import './i18n';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      {/* Above the router so a page can read its copy on first render rather
          than after a navigation. */}
      <SiteContentProvider>
        <App />
      </SiteContentProvider>
    </HelmetProvider>
  </StrictMode>,
);
